import React from 'react';
import { ButtonDropdown, IDropdownAnchor } from 'ui-toolkit';
import '../../scss/_add-row-actions.scss';
import styled from 'styled-components';
import { magicNumbersForStyling } from './magicNumbersForStyling';
import { mergeTests } from '../../ui-toolkit/test-utilities/mergeTests';
import { IHasTestData } from '../../ui-toolkit/test-utilities/IHasTestData';

export interface IAddRowAction {
  key: string;
  text: string;
  handler: (key: string) => void;
}

interface IAddRowActionsProps extends IHasTestData {
  addRowActions: IAddRowAction[];
  className?: string;
  disabled?: boolean;
}

interface IAddRowActionsState {
  showMenu: boolean;
}

export default class AddRowActions extends React.Component<IAddRowActionsProps, IAddRowActionsState> {
  private dropdown = React.createRef<HTMLDivElement>();

  constructor(props: IAddRowActionsProps) {
    super(props);
    this.onBottomButtonEvent = this.onBottomButtonEvent.bind(this);
    this.onMouseDownEvent = this.onMouseDownEvent.bind(this);
    this.state = {
      showMenu: false,
    };
  }

  public componentDidMount() {
    document.addEventListener('mousedown', this.onMouseDownEvent);
  }

  public componentWillMount() {
    document.removeEventListener('mousedown', this.onMouseDownEvent);
  }

  public onBottomButtonEvent() {
    const { addRowActions } = this.props;
    if (addRowActions) {
      if (addRowActions.length === 1) {
        addRowActions[0].handler(addRowActions[0].key);
      } else {
        this.setState({
          showMenu: !this.state.showMenu,
        });
      }
    }
  }

  public generateOnDropdownEvent(action: IAddRowAction) {
    return () => {
      this.setState({
        showMenu: !this.state.showMenu,
      });
      action.handler(action.key);
    };
  }
  public render() {
    const { className, addRowActions, 'data-test-id': dataTestID, disabled } = this.props;
    const buttonList = addRowActions.map((action) => ({
      children: <div>{action.text}</div>,
      onClick: this.generateOnDropdownEvent(action),
    }));
    return (
      <div className={`add-row-actions ${className || ''}`}>
        <ButtonDropdown
          children={<div>+ Add Row </div>}
          items={buttonList}
          intent={'secondary'}
          anchor={IDropdownAnchor.bottomRight}
          data-test-id={mergeTests(dataTestID, 'button')}
          disabled={disabled}
        />
      </div>
    );
  }

  protected onMouseDownEvent(event: MouseEvent) {
    const node = this.dropdown.current;
    if (node && !node.contains(event.target as HTMLElement)) {
      this.setState({
        showMenu: false,
      });
    }
  }
}

const { numberColumnWidth, rowHeight } = magicNumbersForStyling;
export const AddRowActionsFooter = styled(AddRowActions)`
  align-items: center;
  display: grid;
  justify-content: space-between;
  padding-left: ${numberColumnWidth};
  min-height: ${rowHeight};
`;
